<template>
  <div class="d-flex">
    <v-checkbox v-model="isChecked" class="mr-4" :label="prefix"></v-checkbox>
    <v-text-field
      v-model="text"
      :disabled="!isChecked"
      :rules="[v => isChecked && v.length === 0 ? '請填寫內容' : true]"
      single-line>
    </v-text-field>
  </div>
</template>
<script>
import { remove, cloneDeep } from 'lodash'
export default {
  props: {
    array: Array
  },
  data: () => ({
    isChecked: false,
    prefix: '其它:',
    text: ''
  }),
  model: {
    prop: 'array',
    event: 'change'
  },
  watch: {
    isChecked (newVal, oldVal) {
      if (newVal) {
        this.array.push(this.value)
        return
      }
      const array = cloneDeep(this.array)
      remove(array, (item) => item === this.value)
      this.$emit('change', array)
    },
    text (newText, oldText) {
      if (!this.isChecked) return
      const i = this.array.findIndex((item) => item === `${this.prefix}${oldText}`)
      if (i === -1) { throw new Error('在陣列中找不到對應的內容') }
      this.array[i] = this.value
    }
  },
  methods: {
    reset () {
      this.isChecked = false
      this.text = ''
    }
  },
  computed: {
    value () {
      return `${this.prefix}${this.text}`
    }
  }
}
</script>
